import { ReactNode } from "react";
import Spinner from "rivals/components/shared/Spinner";
import { PATHS } from "rivals/shared/constants";
import styles from "./UserAlertListDropdown.module.scss";
import strings from "./strings";
import type { Props } from "./types";

const UserAlertListDropdown = ({
  hasAlerts,
  isLoading,
  optionsNode,
  onClickMarkUserAlertsRead
}: Props): ReactNode => {
  return (
    <div className={styles.userAlertListDropdown}>
      <div className={styles.userAlertListDropdownHeader}>{strings.header}</div>
      <div className={styles.infiniteScrollContainer}>
        {!hasAlerts && !isLoading && strings.noAlerts}
        {hasAlerts && optionsNode}
        <div className={styles.infiniteScrollLoadingGraphic}>
          {isLoading && <Spinner />}
        </div>
      </div>
      <div className={styles.userAlertListDropdownFooter}>
        <button
          className={styles.userAlertListDropdownMarkReadButton}
          onClick={onClickMarkUserAlertsRead}
        >
          {strings.markRead}
        </button>
        <div className={styles.userAlertListDropdownFooterSeparator}>
          &middot;
        </div>
        <a
          className={styles.userAlertListDropdownFooterPreferences}
          href={PATHS.NOTIFICATIONS}
        >
          {strings.preferences}
        </a>
      </div>
    </div>
  );
};

export default UserAlertListDropdown;
